import { render, staticRenderFns } from "./BarsWave.vue?vue&type=template&id=2639753d&scoped=true&"
import script from "./BarsWave.vue?vue&type=script&lang=js&"
export * from "./BarsWave.vue?vue&type=script&lang=js&"
import style0 from "./BarsWave.vue?vue&type=style&index=0&id=2639753d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639753d",
  null
  
)

export default component.exports